
export default {
    state: {
        custombgcolor: "",
        showFill: false
    },
    getters: {
        showFill: state => {
            return state.showFill
        }
    },
    mutations: {
        toggleShowFill(state, value) {
            state.showFill = value
        },
        setBgColor(state, color) {
            state.custombgcolor = color
        }
    },
    actions: {
    }
}
